import React from "react";
import { Box, Grid, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import InputCst from "@components/InputCst/InputCst";
import { WizardStepProps } from "@components/WizardCst/types";
import { ActivityWizardData } from "../../../types";

const VersioningSection: React.FC<WizardStepProps<ActivityWizardData>> = () => {
  const { t } = useTranslation("wizard-activity");
  const theme = useTheme();

  // I tre campi sono read-only in v1 (disabled:true) — popolati dal BE in edit dopo upload.
  // In creazione restano placeholder vuoti disabilitati.
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <Typography
        sx={{
          fontSize: "16px",
          fontWeight: 700,
          color: theme.palette.text.primary,
        }}
      >
        {t("sections.versioning.title")}
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <InputCst
            id="activity-actual-package-version"
            label={t("fields.actual-package-version") || ""}
            value=""
            disabled
            onChange={() => {}}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <InputCst
            id="activity-available-package-version"
            label={t("fields.available-package-version") || ""}
            value=""
            disabled
            onChange={() => {}}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <InputCst
            id="activity-update-package"
            label={t("fields.update-package") || ""}
            value=""
            disabled
            onChange={() => {}}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default VersioningSection;
